(() => {
  if (window.PsychicHermanoProductConversion) return;
  window.PsychicHermanoProductConversion = true;

  const MOBILE_BREAKPOINT = 750;

  const findPriceText = (sectionId) => {
    const priceRoot = document.getElementById(`price-${sectionId}`);
    if (!priceRoot) return "";
    const sale = priceRoot.querySelector(".price-item--sale");
    const regular = priceRoot.querySelector(".price-item--regular");
    return (sale || regular || priceRoot).textContent.trim().replace(/\s+/g, " ");
  };

  const normalizeProductHeadings = () => {
    document.querySelectorAll('.product__title > a.product__title > h2').forEach((heading) => {
      const replacement = document.createElement('span');
      replacement.className = heading.className;
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });

    const support = document.querySelector('[data-ph-product-support]');
    const relatedHeading = support?.dataset.phRelatedHeading;
    if (!relatedHeading) return;

    document.querySelectorAll('.related-products__heading').forEach((heading) => {
      if (heading.textContent.trim() !== relatedHeading) heading.textContent = relatedHeading;
    });
  };

  const initializeMarker = (marker) => {
    if (marker.dataset.phInitialized === "true") return;
    marker.dataset.phInitialized = "true";

    const sectionId = marker.dataset.phSection;
    const kind = marker.dataset.phKind || "physical";
    const productInfo = marker.closest("product-info") || marker.closest(".product__info-container");
    const bar = document.querySelector(`[data-ph-mobile-bar="${CSS.escape(sectionId)}"]`);

    if (productInfo) {
      productInfo.classList.add(`ph-product-kind--${kind}`);
      if (kind === "reading" || kind === "spell") productInfo.classList.add("ph-service-product");
    }

    if (!bar) return;

    const barButton = bar.querySelector("[data-ph-mobile-submit]");
    const barLabel = bar.querySelector("[data-ph-mobile-label]");
    const barPrice = bar.querySelector("[data-ph-mobile-price]");
    const getMainButton = () => document.getElementById(`ProductSubmitButton-${sectionId}`);

    const sync = () => {
      const mainButton = getMainButton();
      if (!mainButton || !barButton) return;
      barButton.disabled = mainButton.disabled;
      const mainLabel = mainButton.querySelector("span");
      if (mainLabel && barLabel) barLabel.textContent = mainLabel.textContent.trim();
      const price = findPriceText(sectionId);
      if (price && barPrice) barPrice.textContent = price;
    };

    barButton?.addEventListener("click", () => {
      const mainButton = getMainButton();
      if (mainButton && !mainButton.disabled) mainButton.click();
    });

    const updateVisibility = (mainButtonVisible = false) => {
      if (window.innerWidth >= MOBILE_BREAKPOINT) {
        bar.hidden = true;
        return;
      }
      bar.hidden = mainButtonVisible;
    };

    const observeMainButton = () => {
      const mainButton = getMainButton();
      if (!mainButton) return;
      const buttonObserver = new IntersectionObserver(
        (entries) => updateVisibility(entries[0]?.isIntersecting === true),
        { threshold: 0.12 }
      );
      buttonObserver.observe(mainButton);
      const stateObserver = new MutationObserver(sync);
      stateObserver.observe(mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
    };

    const priceRoot = document.getElementById(`price-${sectionId}`);
    if (priceRoot) {
      const priceObserver = new MutationObserver(sync);
      priceObserver.observe(priceRoot, { childList: true, subtree: true, characterData: true });
    }

    window.addEventListener("resize", () => updateVisibility(false), { passive: true });
    document.addEventListener("variant:change", sync);
    document.addEventListener("product:variant-change", sync);

    observeMainButton();
    sync();
  };

  const initializeAll = () => {
    document.querySelectorAll("[data-ph-conversion-marker]").forEach(initializeMarker);
    normalizeProductHeadings();
  };

  initializeAll();
  const documentObserver = new MutationObserver(initializeAll);
  documentObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
